import React, { Component } from "react";
import myConfig from "../../configs/config";
import Kpi_gadget from "../../components/gadgets/Kpi_gadget";
import Title from "../../components/Title";
import MapContainer from "../../components/Polygon_map";
import Button from "../../components/Button";
import axios from "axios";
import "../../../src/App.css";
import classnames from "classnames";
import MDSpinner from "react-md-spinner";
import {
  getErrorComponent,
  default_error_message,
  changeToBrowserTimezone,
  buildUtcRangeQueryParams,
  getFormatedDate,
  getTime,
  distance,
} from "../../helpers/utils";
import { withTranslation } from "react-i18next";
import SimpleModal from "./SimpleModal";
import AgriDateTime from "../../components/AgriDateTime";
import {
  calculatePeriodMotionStats,
  formatPeriodClockDuration,
  formatPeriodTimestamp,
} from "../../helpers/operationPeriodStats";
import PdfContainer from "../../components/PdfContainer";
import Doc from "../../components/DocService";
import OperationReprocess from "./Reprocess";
import OperationReport from "./Report";
import ProductsModal from "./ProductsModal";
import CreateLandplotModal from "./CreateLandplotModal";
import ConfirmApplicationModal from "./ConfirmApplicationModal";
import ScheduledBadge, {
  getObsCardClass,
  ObservationExecutionInfo,
} from "./ScheduledBadge";
import { getObservationMapPeriod, hasExecutedPeriod } from "../../helpers/observationDateUtils";
import { usePendingSchedules } from "../../contexts/PendingSchedulesContext";
import {
  FaPen,
  FaTrashAlt,
  FaCheckCircle,
  FaFileAlt,
  FaSearch,
  FaLeaf,
  FaInfoCircle,
  FaCalendarAlt,
  FaDrawPolygon,
  FaFilter,
  FaTachometerAlt,
  FaArrowLeft,
} from "react-icons/fa";
import SelectBox from "../../components/SelectBox";
import LineGraph from "./LineGraph";
import CardContent from "../../components/CardContent";
import { toast, ToastContainer } from "react-toastify";
import {
  buildDisplayActivityLanes,
  buildMachineLanesMatchingGraph,
} from "../FieldApp/GraphActivityLanesLayer";
import { fuelStatsForRange } from "../FieldApp/FieldAppActivityTimeline";
import FieldAppActivitySessionDetail from "../FieldApp/FieldAppActivitySessionDetail";
import {
  dayKeyFromIso,
  graphIndicesForTimeRange,
} from "../FieldApp/fieldAppPeriodUtils";
import FieldAppTimezoneToggle from "../FieldApp/FieldAppTimezoneToggle";
import FieldAppMachineSchedulePanel from "../FieldApp/FieldAppMachineSchedulePanel";
import { fetchMachineSchedule } from "../FieldApp/fieldAppApi";
import {
  loadWeatherInfoWindowHtml,
  weatherLoadingHtml,
} from "../FieldApp/fieldAppWeather";
import {
  POINT_DETAILS_INFO_WINDOW_MS,
  pointDetailsInfoWindowHtml,
} from "../FieldApp/pointDetailsInfoWindow";
import { formatRelativeTime } from "../../helpers/utils";
import { fetchGroupFarms } from "../PendingSchedules/serviceOrderLocationApi";
import {
  landPlotIdsForSubFarm,
  resolveSubFarmIdForPlot,
} from "../../utils/mapMeasurements";
import {
  formatFieldAppDateTime,
  readTrackingTimezoneMode,
  writeTrackingTimezoneMode,
} from "../FieldApp/fieldAppTimezoneDisplay";
import OperationFieldEventsPanel from "./OperationFieldEventsPanel";
import FieldAppHarvestLossOrderResults from "../FieldApp/FieldAppHarvestLossOrderResults";
import { showsHarvestLossFields } from "../../constants/serviceOrderTypes";
import "../FieldApp/FieldAppHarvestLossOrderResults.css";
import {
  emptyFieldEventSummary,
  normalizeFieldEventSummary,
} from "./operationFieldEventsSummary";
import {
  normalizeMeterType,
  resolveMeterPresentation,
} from "../FieldApp/fieldAppMeterLabels";
import {
  buildMonitoringMetrics,
  emptyMonitoringMetrics,
  formatFuelRate,
  formatMeterDiff,
  formatMeterValue,
  formatOperatorHourMeterReading,
  formatOperatorPanelHectares,
  formatOperatorPanelHours,
  formatOperatorPanelKm,
  formatOperatorOdometerReading,
  formatPeriodClockDuration as formatMonitoringDuration,
} from "./operationMonitoringMetrics";
import OperationFuelSupplyPanel from "./OperationFuelSupplyPanel";
import OperationMachinePhotosPanel from "./OperationMachinePhotosPanel";
import { collectMachinePanelPhotos } from "./operationMachinePhotos";
import "./OperationFuelSupplyPanel.css";
import {
  extractRawPathPoints,
  rebuildTrackingLines,
  stoppedPointsFromLines,
  buildGraphSeriesFromLines,
  resolveOperatorMapEquipment,
} from "../FieldApp/fieldAppTrackingUtils";
import "../FieldApp/FieldAppHome.css";

const PLANNED_SPEED_STORAGE_PREFIX = "operation-planned-speed-";
const PLANNED_SPEED_MIN = 1;
const PLANNED_SPEED_MAX = 120;
const PLANNED_SPEED_DEFAULT = 15;

function clampPlannedSpeed(value) {
  return Math.min(PLANNED_SPEED_MAX, Math.max(PLANNED_SPEED_MIN, value));
}

function readStoredPlannedSpeed(farmId, operationId) {
  if (!farmId || !operationId) return null;
  try {
    const raw = localStorage.getItem(
      `${PLANNED_SPEED_STORAGE_PREFIX}${farmId}-${operationId}`
    );
    const parsed = Number(raw);
    if (parsed >= PLANNED_SPEED_MIN && parsed <= PLANNED_SPEED_MAX) {
      return parsed;
    }
  } catch (error) {
    /* ignore */
  }
  return null;
}

function writeStoredPlannedSpeed(farmId, operationId, value) {
  try {
    localStorage.setItem(
      `${PLANNED_SPEED_STORAGE_PREFIX}${farmId}-${operationId}`,
      String(value)
    );
  } catch (error) {
    /* ignore */
  }
}

function formatShortDate(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("pt-BR");
  } catch (error) {
    return "—";
  }
}

function buildMapFromLines(apiLines, plannedSpeedKmh) {
  const rawPathPoints = extractRawPathPoints(apiLines || []);
  const lines = rebuildTrackingLines(rawPathPoints, plannedSpeedKmh);
  return {
    rawPathPoints,
    lines,
    stopped_points: stoppedPointsFromLines(lines),
    graphSeries: buildGraphSeriesFromLines(lines),
  };
}

class OperationDetail extends Component {
  operationId = this.props.match.params.operation_id;
  farmId = this.props.match.params.farm_id;

  PROGRESS_DETAIL = `${myConfig.API_URL}/progress/${this.operationId}/?farm_id=${this.farmId}`;

  UPDATE_URL = `${myConfig.ABSOLUTE_URL}${this.farmId}/operation/${this.operationId}/change`;

  ALERT_URL = `${myConfig.ABSOLUTE_URL}alert/alert/${this.operationId}`;

  OPERATION_LIST_URL = `${myConfig.ABSOLUTE_URL}${this.farmId}/operation/`;

  FINISHED_URL = `${myConfig.API_URL}/operation/${this.operationId}/?farm_id=${this.farmId}`;

  DELETE_URL = `${myConfig.API_URL}/operation/${this.operationId}/?farm_id=${this.farmId}`;

  OPERATION_DATETIME = `${myConfig.API_URL}/operation/${this.operationId}/operation_datetime/?farm_id=${this.farmId}`;

  DATA_INIT_OPERATION = "";

  DATA_END_OPERATION = "";

  LANDPLOT_URL = `${myConfig.API_URL}/landplot/?farm_id=${this.farmId}`;

  constructor(props) {
    super(props);
    this.state = {
      farm_id: this.farmId,
      loading: false,
      operacao: "",
      operation: {
        status: {},
      },
      kpi_data: [],
      alert: {},
      alerts: [],
      map: {},
      show: false,
      errors: [],
      operation_id: this.operationId,
      selected: [],
      dt_ini: "",
      dt_end: "",
      dt_created: "",
      period_id: 0,
      periods: [
        { id: 0, name: "Hoje" },
        { id: 1, name: "Ontem" },
        { id: 2, name: "Semana atual" },
        { id: 3, name: "Semana Passada" },
        { id: 4, name: "Período completo" },
      ],
      isSelected: false,
      landplots: [],
      groupFarms: [],
      observation_entries: [],
      showProductsModal: false,
      prefillObservationDate: null,
      filterDate: null,
      showCreateLandplotModal: false,
      confirmingObsId: null,
      liveEquipment: null,
      graphBrushRange: { startIndex: 0, endIndex: null },
      focusBrushRange: null,
      accumulatedHodometer: null,
      accumulatedAlerts: null,
      autoMonitoring: false,
      fieldEvents: [],
      fieldEventOperators: [],
      fieldEventSummary: emptyFieldEventSummary(),
      panelPhotos: [],
      fieldEventsExpanded: false,
      filterOperatorId: "",
      fieldTracking: null,
      timezoneMode: readTrackingTimezoneMode(this.farmId),
      fuelPhotoPreview: null,
      visibleGraphRange: { startTimeMs: null, endTimeMs: null },
      plannedSpeedKmh: PLANNED_SPEED_DEFAULT,
      speedEditorOpen: false,
      speedDraft: String(PLANNED_SPEED_DEFAULT),
      rawPathPoints: [],
      graphSeries: [],
      fuelPeriodStats: {
        totalLiters: 0,
        recordCount: 0,
        avgLitersPerStop: 0,
      },
      lastProgressSnapshot: null,
      selectedActivityInterval: null,
      machineScheduleExpanded: true,
      machineScheduleRows: [],
      machineScheduleMeterType: "hour_meter",
      machineScheduleLoading: false,
      machineScheduleError: null,
      machineScheduleLandplotId: null,
      machineScheduleLandplotName: "",
      machineScheduleSubFarmId: null,
      pendingLandplotName: "",
    };

    this.handleFinished = this.handleFinished.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleChangeDateEnd = this.handleChangeDateEnd.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.choosePeriod = this.choosePeriod.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.handleAddObservation = this.handleAddObservation.bind(this);
    this.handleUpdateObservation = this.handleUpdateObservation.bind(this);
    this.handleDeleteObservation = this.handleDeleteObservation.bind(this);
    this.handleOpenObservationsFromMap =
      this.handleOpenObservationsFromMap.bind(this);
    this.loadObservations = this.loadObservations.bind(this);
    this.handleShowProductsModal = this.handleShowProductsModal.bind(this);
    this.handleCloseProductsModal = this.handleCloseProductsModal.bind(this);
    this.handleShowCreateLandplotModal =
      this.handleShowCreateLandplotModal.bind(this);
    this.handleCloseCreateLandplotModal =
      this.handleCloseCreateLandplotModal.bind(this);
    this.handleLandplotCreated = this.handleLandplotCreated.bind(this);
    this.handleConfirmObservation = this.handleConfirmObservation.bind(this);
    this.handleSubmitConfirmation = this.handleSubmitConfirmation.bind(this);
    this.handleCancelConfirmation = this.handleCancelConfirmation.bind(this);
    this.handleGraphRangeChange = this.handleGraphRangeChange.bind(this);
    this.loadMachineSchedule = this.loadMachineSchedule.bind(this);
    this.handleMachineScheduleToggle = this.handleMachineScheduleToggle.bind(this);
    this.handleMachineScheduleLandplotChange =
      this.handleMachineScheduleLandplotChange.bind(this);
    this.handleMachineScheduleSubFarmChange =
      this.handleMachineScheduleSubFarmChange.bind(this);
    this.applyMachineScheduleFilterDefaults =
      this.applyMachineScheduleFilterDefaults.bind(this);
    this.mapSectionRef = React.createRef();
    this.shouldScrollToMap = false;
    this.progressLoadGeneration = 0;
    this.graphFocusKeyRef = null;
  }

  beginProgressLoad() {
    this.progressLoadGeneration += 1;
    return this.progressLoadGeneration;
  }

  isStaleProgressLoad(generation) {
    return generation !== this.progressLoadGeneration;
  }

  buildProgressMapState(widget, plannedSpeedKmh, autoMonitoring) {
    if (autoMonitoring) {
      return {};
    }
    const mapBuilt = buildMapFromLines(widget.lines, plannedSpeedKmh);
    return {
      rawPathPoints: mapBuilt.rawPathPoints,
      graphSeries: mapBuilt.graphSeries,
      map: {
        centroidLat: widget.centroidLat,
        centroidLng: widget.centroidLng,
        geojson: widget.geojson,
        lines: mapBuilt.lines,
        operation_type: widget.operation_type,
        stopped_points: mapBuilt.stopped_points,
      },
      map_salt: Date.now(),
    };
  }

  scrollToMapSection() {
    window.requestAnimationFrame(() => {
      if (this.mapSectionRef.current) {
        this.mapSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  }

  handleGraphRangeChange(range) {
    const current = this.state.graphBrushRange;
    if (
      current.startIndex === range.startIndex &&
      current.endIndex === range.endIndex &&
      this.state.visibleGraphRange.startTimeMs === range.startTimeMs &&
      this.state.visibleGraphRange.endTimeMs === range.endTimeMs
    ) {
      return;
    }
    this.setState(
      {
        graphBrushRange: range,
        visibleGraphRange: {
          startTimeMs: range.startTimeMs,
          endTimeMs: range.endTimeMs,
        },
      },
      () => this.patchKpiFromLiveData()
    );
  }

  syncGraphFocusFromPeriod() {
    const graphData = this.state.graphSeries || [];
    if (!graphData.length || !this.state.dt_ini || !this.state.dt_end) {
      return;
    }

    const startMs = new Date(this.state.dt_ini).getTime();
    const endMs = new Date(this.state.dt_end).getTime();
    if (Number.isNaN(startMs) || Number.isNaN(endMs)) {
      return;
    }

    const focusKey = [
      startMs,
      endMs,
      graphData.length,
      graphData[0].time,
      graphData[graphData.length - 1].time,
    ].join("|");

    if (this.graphFocusKeyRef === focusKey) {
      return;
    }
    this.graphFocusKeyRef = focusKey;

    const { startIndex, endIndex } = graphIndicesForTimeRange(
      graphData,
      startMs,
      endMs
    );

    this.setState({
      graphBrushRange: {
        startIndex,
        endIndex,
        startTimeMs: startMs,
        endTimeMs: endMs,
      },
      visibleGraphRange: {
        startTimeMs: startMs,
        endTimeMs: endMs,
      },
      focusBrushRange: { startIndex, endIndex },
    });
  }

  handleActivityIntervalClick = (detail) => {
    this.setState({ selectedActivityInterval: detail }, () => {
      window.requestAnimationFrame(() => {
        const panel = document.querySelector(
          ".operation-map-graph-stack .field-app-activity-detail--session"
        );
        if (panel) {
          panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });
    });
  };

  getTrackingOperatorIds() {
    if (this.state.filterOperatorId) {
      return [Number(this.state.filterOperatorId)];
    }
    const tracking = this.state.fieldTracking;
    if (tracking && tracking.operators && tracking.operators.length) {
      return tracking.operators.map((row) => row.id);
    }
    const operator = this.state.operation && this.state.operation.operator;
    if (operator && operator.id) {
      return [operator.id];
    }
    return [];
  }

  getTrackingFuelRecords() {
    const summary =
      this.state.fieldTracking && this.state.fieldTracking.fuelSummary;
    return (summary && summary.records) || [];
  }

  getScheduleOperatorLabel() {
    const tracking = this.state.fieldTracking;
    if (tracking && tracking.operators && tracking.operators.length) {
      return tracking.operators.map((row) => row.name).join(", ");
    }
    const operator = this.state.operation && this.state.operation.operator;
    if (!operator) return "";
    return operator.nome || operator.name || "";
  }

  getSchedulePeriodLabel() {
    if (!this.state.dt_ini || !this.state.dt_end) return "";
    const from = String(this.state.dt_ini).slice(0, 10);
    const to = String(this.state.dt_end).slice(0, 10);
    return `${from} – ${to}`;
  }

  async loadMachineSchedule() {
    if (!this.state.autoMonitoring) return;
    const machineIdent =
      this.state.operation &&
      this.state.operation.machine &&
      this.state.operation.machine.ident;
    if (!machineIdent || !this.state.dt_ini || !this.state.dt_end) return;

    this.setState({
      machineScheduleLoading: true,
      machineScheduleError: null,
    });

    try {
      const data = await fetchMachineSchedule(this.farmId, {
        machineIdent,
        operatorIds: this.getTrackingOperatorIds(),
        dateFrom: this.state.dt_ini,
        dateTo: this.state.dt_end,
        landPlotId: this.state.machineScheduleLandplotId,
      });
      this.setState({
        machineScheduleRows: data.days || [],
        machineScheduleMeterType: data.meterType || "hour_meter",
        machineScheduleLandplotName: data.landPlotName || "",
        machineScheduleLoading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({
        machineScheduleRows: [],
        machineScheduleLoading: false,
        machineScheduleError: this.props.t("Falha ao carregar planilha da máquina"),
      });
    }
  }

  handleMachineScheduleToggle() {
    this.setState(
      (prev) => ({ machineScheduleExpanded: !prev.machineScheduleExpanded }),
      () => {
        if (this.state.machineScheduleExpanded) {
          this.loadMachineSchedule();
        }
      }
    );
  }

  handleMachineScheduleLandplotChange(landplotId) {
    this.setState(
      {
        machineScheduleLandplotId: landplotId,
        machineScheduleLandplotName: "",
      },
      () => {
        if (this.state.machineScheduleExpanded) {
          this.loadMachineSchedule();
        }
      }
    );
  }

  handleMachineScheduleSubFarmChange(subFarmId) {
    const { landplots, groupFarms, machineScheduleLandplotId } = this.state;
    let nextLandplotId = machineScheduleLandplotId;
    if (subFarmId && nextLandplotId) {
      const allowedIds = landPlotIdsForSubFarm(
        landplots,
        subFarmId,
        groupFarms
      ).map(Number);
      if (!allowedIds.includes(Number(nextLandplotId))) {
        nextLandplotId = null;
      }
    }
    this.setState(
      {
        machineScheduleSubFarmId: subFarmId,
        machineScheduleLandplotId: nextLandplotId,
        machineScheduleLandplotName: "",
      },
      () => {
        if (this.state.machineScheduleExpanded) {
          this.loadMachineSchedule();
        }
      }
    );
  }

  applyMachineScheduleFilterDefaults(landplots, groupFarms) {
    if (this.machineScheduleDefaultsApplied) return;
    const pendingName = (this.state.pendingLandplotName || "").trim();
    if (!pendingName || !Array.isArray(landplots) || !landplots.length) {
      return;
    }

    const plot =
      landplots.find((item) => item.name === pendingName) ||
      landplots.find((item) => pendingName.startsWith(String(item.name || "")));

    if (!plot) return;

    this.machineScheduleDefaultsApplied = true;
    const subFarmId = resolveSubFarmIdForPlot(plot, groupFarms) || plot.farm || null;
    this.setState(
      {
        machineScheduleLandplotId: plot.id,
        machineScheduleLandplotName: plot.name || "",
        machineScheduleSubFarmId: subFarmId,
      },
      () => {
        if (this.state.machineScheduleExpanded && this.state.autoMonitoring) {
          this.loadMachineSchedule();
        }
      }
    );
  }

  formatTrackingTimestamp = (timeMs) =>
    this.formatChartTime(timeMs, "card");

  _getVisibleRawPathPoints() {
    const points = this.state.rawPathPoints || [];
    if (!points.length) return [];

    const visibleSeries = this._getVisibleGraphSeries();
    if (!visibleSeries.length) return points;

    const startMs = visibleSeries[0].time;
    const endMs = visibleSeries[visibleSeries.length - 1].time;
    return points.filter((point) => {
      const timeMs = new Date(point.time).getTime();
      if (Number.isNaN(timeMs)) return false;
      return timeMs >= startMs && timeMs <= endMs;
    });
  }

  computeMonitoringMetrics() {
    if (!this.state.autoMonitoring) return emptyMonitoringMetrics();

    const periodFuelStats = this.getFullPeriodFuelStats();
    const snapshot = this.state.lastProgressSnapshot;
    const operationType =
      (snapshot && snapshot.widget && snapshot.widget.operation_type) ||
      this.state.map.operation_type ||
      "field_app";
    const areaHa =
      Number(this.state.operation.area) ||
      Number(snapshot && snapshot.operation && snapshot.operation.worked_area && snapshot.operation.worked_area.area) ||
      0;

    return buildMonitoringMetrics({
      fuelLiters: periodFuelStats.totalLiters,
      areaHa,
      pathPoints: this._getVisibleRawPathPoints(),
      graphSeries: this._getVisibleGraphSeries(),
      fieldEvents: this.state.fieldEvents,
      operationType,
      machineMeterType: normalizeMeterType(
        this.state.operation &&
          this.state.operation.machine &&
          this.state.operation.machine.meter_type
      ),
    });
  }

  _getGraphSeries() {
    return this.handleGraphData();
  }

  _getVisibleGraphSeries() {
    const series = this._getGraphSeries();
    if (!series.length) return [];

    const { startIndex, endIndex } = this.state.graphBrushRange;
    const safeEnd =
      endIndex == null || endIndex >= series.length
        ? series.length - 1
        : endIndex;

    return series.slice(startIndex, safeEnd + 1);
  }

  getPeriod = () =>
    (new Date(this.state.dt_end).getTime() -
      new Date(this.state.dt_ini).getTime()) /
    (24 * 60 * 60 * 1000);

  buildKpiData(
    operation,
    widget,
    plannedSpeedKmh,
    fuelPeriodStats,
    periodStart,
    periodEnd,
    fieldEventSummary,
    autoMonitoring,
    monitoringMetrics
  ) {
    const { t } = this.props;
    const fuelPeriod = fuelPeriodStats || {};
    const fieldSummary = fieldEventSummary || emptyFieldEventSummary();
    const metrics = monitoringMetrics || emptyMonitoringMetrics();
    const avgRangeLabel =
      periodStart && periodEnd
        ? `${formatShortDate(periodStart)} – ${formatShortDate(periodEnd)}`
        : t("intervalo");

    const fuelStats =
      fuelPeriod.recordCount > 0
        ? fuelPeriod
        : {
            recordCount: fieldSummary.fuelCount,
            totalLiters: fieldSummary.totalLiters,
            avgLitersPerStop: fieldSummary.avgLitersPerStop,
          };

    const machineMeterType = normalizeMeterType(
      operation.machine && operation.machine.meter_type
    );
    const meterPresentation = resolveMeterPresentation(machineMeterType, t);
    const panelUsesKmOnly =
      meterPresentation.usesKm && !meterPresentation.usesHours;
    const panelFromGps =
      panelUsesKmOnly && Boolean(metrics.operatorPanelKmFromGps);
    const panelKmValue =
      metrics.operatorPanelKm != null
        ? metrics.operatorPanelKm
        : panelUsesKmOnly
          ? metrics.gpsDistanceKm
          : null;
    const panelLabel = panelFromGps
      ? t("Quilômetros percorridos (GPS)")
      : panelUsesKmOnly
        ? t("Quilômetros no painel")
        : t("Horas no painel");
    const panelValue = panelUsesKmOnly
      ? formatOperatorPanelKm(panelKmValue)
      : formatOperatorPanelHours(metrics.operatorPanelHours);
    const panelSessions = panelUsesKmOnly
      ? metrics.operatorPanelKmSessions
      : metrics.operatorPanelHoursSessions;
    const lastReadingAt = panelUsesKmOnly
      ? metrics.operatorLastOdometerAt
      : metrics.operatorLastHourMeterAt;
    const lastReadingValue = panelUsesKmOnly
      ? formatOperatorOdometerReading(metrics.operatorLastOdometer)
      : formatOperatorHourMeterReading(metrics.operatorLastHourMeter);
    const lastReadingLabel = panelUsesKmOnly
      ? t("Último hodômetro registrado")
      : t("Último horímetro registrado");
    const operatorMeterLabel = panelUsesKmOnly ? t("hodômetro") : t("horímetro");
    const operatorMeterValue =
      metrics.operatorMeterDelta == null
        ? panelUsesKmOnly && metrics.gpsDistanceKm != null
          ? formatOperatorPanelKm(metrics.gpsDistanceKm)
          : "—"
        : panelUsesKmOnly
          ? formatOperatorPanelKm(metrics.operatorMeterDelta)
          : metrics.meterMode === "hectare"
            ? formatMeterValue(metrics.operatorMeterDelta, metrics.meterMode)
            : formatOperatorPanelKm(metrics.operatorMeterDelta);

    const baseCards = [
      {
        label_header: t("Velocidade Atual") + ": ",
        header_value: operation.planned_speed.msg,
        header_class: operation.planned_speed.color,
        content_header: "",
        content_value: operation.planned_speed.value + " km/h ",
        content_class: operation.planned_speed.color,
        footer_header: t("Velocidade Planejada") + ": ",
        footer_value: `${plannedSpeedKmh} km/h`,
      },
      {
        label_header: t("Área Trabalhada") + ": ",
        header_value:
          widget.operation_type === "covering"
            ? operation.worked_area.worked + "%"
            : 0,
        content_header: "",
        content_value: operation.worked_area.area + " ha ",
        content_class: " yellow ",
        footer_header: t("Area Total") + ": ",
        footer_value:
          widget.operation_type === "covering"
            ? operation.area + " ha "
            : 0,
      },
      autoMonitoring
        ? {
            label_header: lastReadingLabel + ": ",
            header_value: "",
            label_help: t("operationMonitoringLastHourMeterHelp"),
            content_header: "",
            content_value: lastReadingValue,
            content_class: " green ",
            footer_header:
              lastReadingAt != null
                ? t("Registrado em") + ": "
                : t("Período") + ": ",
            footer_value:
              lastReadingAt != null
                ? formatPeriodTimestamp(new Date(lastReadingAt).getTime())
                : avgRangeLabel,
          }
        : {
            label_header: t("Previsão Termino") + ": ",
            header_value: "",
            content_header: "",
            content_value:
              widget.operation_type === "covering"
                ? operation.remain_time.remain
                : "0h00min",
            content_class: " green ",
            footer_header: t("Início") + ": ",
            footer_value:
              operation.init_point !== ""
                ? operation.init_point
                : "Aguardando ...",
          },
      {
        label_header: t("Tempo Total") + ": ",
        header_value: "",
        content_header: "",
        content_value: operation.total_time,
        content_class: " green ",
        footer_header: "",
        footer_value: "Eficiência : " + operation.op_efficiency_pc,
      },
    ];

    if (!autoMonitoring) {
      return [
        ...baseCards,
        {
          label_header: t("Combustível no período") + ": ",
          header_value:
            fuelStats.recordCount > 0
              ? `${fuelStats.recordCount} ${t("abast.")}`
              : "",
          content_header: "",
          content_value:
            fuelStats.recordCount > 0 ? `${fuelStats.totalLiters} L` : "—",
          content_class: " green ",
          footer_header: t("Média") + ` (${avgRangeLabel}): `,
          footer_value:
            fuelStats.recordCount > 0
              ? `${fuelStats.avgLitersPerStop} L/${t("abast.")} · ${fuelStats.totalLiters} L`
              : "—",
        },
      ];
    }

    const eventsWithPhoto =
      fieldSummary.assumeCount + fieldSummary.fuelCount || 0;

    return [
      ...baseCards,
      {
        label_header: t("Combustível total") + ": ",
        header_value:
          fuelStats.recordCount > 0
            ? `${fuelStats.recordCount} ${t("abast.")}`
            : "",
        content_header: "",
        content_value:
          fuelStats.recordCount > 0 ? `${fuelStats.totalLiters} L` : "—",
        content_class: " green ",
        footer_header: t("Período") + ": ",
        footer_value: avgRangeLabel,
      },
      {
        label_header: t("Média por abastecimento") + ": ",
        header_value: "",
        content_header: "",
        content_value:
          fuelStats.recordCount > 0
            ? `${fuelStats.avgLitersPerStop} L`
            : "—",
        content_class: " green ",
        footer_header: t("Total") + ": ",
        footer_value:
          fuelStats.recordCount > 0 ? `${fuelStats.totalLiters} L` : "—",
      },
      {
        label_header: t("Hectares no painel") + ": ",
        header_value: t("informado pelo operador"),
        content_header: "",
        content_value: formatOperatorPanelHectares(
          metrics.operatorPanelHectares
        ),
        content_class: " green ",
        footer_header: t("Turnos com leitura") + ": ",
        footer_value:
          metrics.operatorPanelHectaresSessions > 0
            ? String(metrics.operatorPanelHectaresSessions)
            : "—",
      },
      {
        label_header: t("Fotos sincronizadas") + ": ",
        header_value: "",
        content_header: "",
        content_value:
          fieldSummary.photoCount > 0
            ? `${fieldSummary.photoCount}`
            : "—",
        content_class: " green ",
        footer_header: t("Registros com foto") + ": ",
        footer_value:
          eventsWithPhoto > 0
            ? `${fieldSummary.photoCount} / ${eventsWithPhoto}`
            : "—",
      },
      {
        label_header: t("Operadores (app)") + ": ",
        header_value: "",
        content_header: "",
        content_value:
          fieldSummary.operatorCount > 0
            ? String(fieldSummary.operatorCount)
            : "—",
        content_class: " green ",
        footer_header: t("Eventos de campo") + ": ",
        footer_value:
          fieldSummary.fuelCount + fieldSummary.assumeCount > 0
            ? String(fieldSummary.fuelCount + fieldSummary.assumeCount)
            : "—",
      },
      {
        label_header:
          metrics.meterMode === "hectare"
            ? t("Consumo médio L/ha") + ": "
            : t("Consumo médio L/km") + ": ",
        header_value:
          metrics.meterMode === "hectare" && metrics.areaHa > 0
            ? `${metrics.areaHa.toFixed(2)} ha`
            : metrics.gpsDistanceKm != null
              ? `${metrics.gpsDistanceKm} km GPS`
              : "",
        content_header: "",
        content_value:
          metrics.meterMode === "hectare"
            ? formatFuelRate(metrics.fuelPerHa, "L/ha")
            : formatFuelRate(metrics.fuelPerKm, "L/km"),
        content_class: " green ",
        footer_header: t("L/h em movimento") + ": ",
        footer_value: formatFuelRate(metrics.fuelPerHour, "L/h"),
      },
      {
        label_header: panelLabel + ": ",
        header_value: t("informado pelo operador"),
        content_header: "",
        content_value: panelValue,
        content_class: " green ",
        footer_header: t("Turnos com leitura") + ": ",
        footer_value:
          panelSessions > 0 ? String(panelSessions) : "—",
      },
      {
        label_header: t("Registro do operador") + ": ",
        header_value:
          metrics.operatorSessionCount > 0
            ? `${metrics.operatorSessionCount} ${t("sessões")}`
            : operatorMeterLabel,
        content_header: "",
        content_value: operatorMeterValue,
        content_class: " green ",
        footer_header: t("Informado no app") + ": ",
        footer_value:
          metrics.operatorMeterDelta != null ? operatorMeterValue : "—",
      },
      {
        label_header: t("Diferença operador × GPS") + ": ",
        header_value:
          metrics.meterDiff != null
            ? metrics.meterDiff > 0
              ? t("operador maior")
              : metrics.meterDiff < 0
                ? t("GPS maior")
                : t("iguais")
            : "",
        content_header: "",
        content_value: formatMeterDiff(metrics.meterDiff, metrics.meterMode),
        content_class:
          metrics.meterDiff != null && Math.abs(metrics.meterDiff) > 0.5
            ? " yellow "
            : " green ",
        footer_header: t("Operador − GPS") + ": ",
        footer_value:
          metrics.operatorMeterDelta != null && metrics.gpsMotionValue != null
            ? `${formatMeterValue(metrics.operatorMeterDelta, metrics.meterMode)} − ${formatMeterValue(metrics.gpsMotionValue, metrics.meterMode)}`
            : "—",
      },
      {
        label_header: t("Parado c/ motor") + ": ",
        header_value: t("telemetria ativa"),
        content_header: "",
        content_value: formatMonitoringDuration(metrics.engineStoppedMs),
        content_class: " yellow ",
        footer_header: t("Velocidade ≈ 0, com sinal") + ": ",
        footer_value: formatMonitoringDuration(metrics.engineStoppedMs),
      },
    ];
  }

  patchKpiFromLiveData() {
    const snapshot = this.state.lastProgressSnapshot;
    if (!snapshot) return;
    const monitoringMetrics = this.computeMonitoringMetrics();
    this.setState({
      kpi_data: this.buildKpiData(
        snapshot.operation,
        snapshot.widget,
        this.state.plannedSpeedKmh,
        this.state.fuelPeriodStats,
        this.state.dt_ini,
        this.state.dt_end,
        this.state.fieldEventSummary,
        this.state.autoMonitoring,
        monitoringMetrics
      ),
    });
  }

  handleTimezoneModeChange = (mode) => {
    writeTrackingTimezoneMode(this.farmId, mode);
    this.setState({ timezoneMode: mode, map_salt: Date.now() });
  };

  formatChartTime = (timeMs, variant) =>
    formatFieldAppDateTime(timeMs, this.state.timezoneMode, variant);

  formatTraceTime = (time) =>
    formatFieldAppDateTime(time, this.state.timezoneMode, "map");

  formatEventTimestamp = (value) =>
    formatFieldAppDateTime(value, this.state.timezoneMode, "card");

  toggleFieldEventsExpanded = () => {
    this.setState((prev) => ({
      fieldEventsExpanded: !prev.fieldEventsExpanded,
    }));
  };

  toggleSpeedEditor = () => {
    this.setState((prev) => ({
      speedEditorOpen: !prev.speedEditorOpen,
      speedDraft: String(prev.plannedSpeedKmh),
    }));
  };

  applyPlannedSpeed = () => {
    const value = clampPlannedSpeed(Number(this.state.speedDraft));
    writeStoredPlannedSpeed(this.farmId, this.operationId, value);
    this.setState(
      {
        plannedSpeedKmh: value,
        speedDraft: String(value),
        speedEditorOpen: false,
      },
      () => {
        this.rebuildMapFromPlannedSpeed();
        this.patchKpiFromLiveData();
      }
    );
  };

  rebuildMapFromPlannedSpeed() {
    const { rawPathPoints, map, plannedSpeedKmh } = this.state;
    if (!rawPathPoints.length || !map) return;
    const lines = rebuildTrackingLines(rawPathPoints, plannedSpeedKmh);
    this.setState({
      map: {
        ...map,
        lines,
        stopped_points: stoppedPointsFromLines(lines),
      },
      graphSeries: buildGraphSeriesFromLines(lines),
      map_salt: Date.now(),
    });
  }

  createPdf = (html) => Doc.createPdf(html);

  handleMessage() {
    alert(
      "Está operação necessita estar finalizada para poder gerar o relatório.",
    );
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChangeDateEnd(e) {
    this.setState({
      dt_end: getFormatedDate(e),
    });
  }

  handleStartDateChange(e) {
    this.setState({
      dt_ini: getFormatedDate(e),
    });
  }

  handleStartTimeChange(e) {
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    var data = new Date(this.state.dt_ini);
    data = new Date(
      data.toLocaleDateString("en-US", options) + " " + e.target.value,
    );
    this.setState({ dt_ini: getFormatedDate(data) });
  }

  handleEndTimeChange(e) {
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    var data = new Date(this.state.dt_end);
    data = new Date(
      data.toLocaleDateString("en-US", options) + " " + e.target.value,
    );
    this.setState({ dt_end: getFormatedDate(data) });
  }

  handleFinished(event) {
    event.preventDefault();

    if (this.state.autoMonitoring) {
      alert(
        "Esta operação é de monitoramento automático e não deve ser finalizada aqui.\n\n" +
          "A máquina continua cadastrada em Equipamentos → Máquinas.",
      );
      return;
    }

    if (
      !window.confirm(
        "Deseja finalizar esta operação?\n\n" +
          "• A máquina NÃO será removida do cadastro.\n" +
          "• Apenas este registro de operação será encerrado.",
      )
    ) {
      return;
    }

    const form_data = new FormData();
    form_data.append("fineshed_at", new Date().toISOString());
    form_data.append("fineshed", true);

    axios({
      method: "PATCH",
      url: this.FINISHED_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
      data: form_data,
    }).then(() => {
      alert("Operação finalizada com sucesso!");
      window.location.href = `/${this.farmId}/operation/${this.operationId}/progress`;
    });
  }

  handleShowProductsModal() {
    this.setState({
      showProductsModal: true,
      prefillObservationDate: null,
      filterDate: null,
    });
  }

  handleCloseProductsModal() {
    this.setState({
      showProductsModal: false,
      prefillObservationDate: null,
      filterDate: null,
    });
  }

  handleShowCreateLandplotModal() {
    console.log("Abrindo modal de criar talhão");
    this.setState({ showCreateLandplotModal: true });
  }

  handleCloseCreateLandplotModal() {
    this.setState({ showCreateLandplotModal: false });
  }

  handleLandplotCreated() {
    // Recarrega a lista de talhões
    this.loadLandPlots();
    toast.success(this.props.t("Talhão criado com sucesso!"), {
      position: "bottom-right",
      autoClose: 3000,
    });
  }

  async loadObservations() {
    try {
      const response = await axios({
        method: "get",
        url: `${myConfig.API_URL}/observation/?operation_id=${this.operationId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      this.setState({ observation_entries: response.data }, () => {
        this.applyObservationFilterFromUrl(response.data);
      });
    } catch (error) {
      console.error("Error loading observations:", error);
    }
  }

  applyObservationFilterFromUrl(entries) {
    const params = new URLSearchParams(window.location.search);
    const filterObsId = params.get("filter_obs");
    if (!filterObsId || !Array.isArray(entries)) return;

    const obs = entries.find((item) => String(item.id) === String(filterObsId));
    if (obs) {
      this.handleFilterByObservation(obs);
    }
  }

  getTelemetryReturnUrl() {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("return_to");
    if (!raw) return null;
    if (!raw.startsWith("/")) return null;
    return raw;
  }

  handleReturnToTelemetry = () => {
    const url = this.getTelemetryReturnUrl();
    if (url) {
      window.location.href = url;
    }
  };

  applyTelemetryDayFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const dayKey = params.get("telemetry_day");
    if (!dayKey || !/^\d{4}-\d{2}-\d{2}$/.test(dayKey)) {
      return;
    }
    const start = new Date(`${dayKey}T00:00:00`);
    const end = new Date(`${dayKey}T23:59:59`);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return;
    }
    this.setState(
      {
        dt_ini: getFormatedDate(start),
        dt_end: getFormatedDate(end),
        selected: [start, end],
      },
      () => {
        this.handleFilter(null);
      }
    );
  }

  async handleAddObservation(data) {
    try {
      await axios({
        method: "post",
        url: `${myConfig.API_URL}/observation/`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
        data: {
          operation: this.operationId,
          start_date: data.start_date,
          end_date: data.end_date,
          products_used: data.products_used,
          description: data.description,
          ...(data.visible_at ? { visible_at: data.visible_at } : {}),
          ...(data.operator_ids ? { operator_ids: data.operator_ids } : {}),
        },
      });
      this.loadObservations();
      if (this.props.refreshPending) {
        this.props.refreshPending();
      }
      toast.success(this.props.t("Observação adicionada com sucesso!"), {
        position: "bottom-right",
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(this.props.t("Erro ao adicionar observação"), {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }

  async handleUpdateObservation(id, data) {
    try {
      await axios({
        method: "patch",
        url: `${myConfig.API_URL}/observation/${id}/`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
        data: data,
      });
      this.loadObservations();
      toast.success(this.props.t("Observação atualizada com sucesso!"), {
        position: "bottom-right",
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(this.props.t("Erro ao atualizar observação"), {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }

  async handleDeleteObservation(id) {
    if (!window.confirm(this.props.t("Deseja excluir esta observação?")))
      return;
    try {
      await axios({
        method: "delete",
        url: `${myConfig.API_URL}/observation/${id}/`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      this.loadObservations();
      toast.success(this.props.t("Observação excluída com sucesso!"), {
        position: "bottom-right",
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(this.props.t("Erro ao excluir observação"), {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }

  handleConfirmObservation(id) {
    this.setState({ confirmingObsId: id });
  }

  handleCancelConfirmation() {
    this.setState({ confirmingObsId: null });
  }

  async handleSubmitConfirmation(confirmedAt) {
    const id = this.state.confirmingObsId;
    if (!id) return;
    try {
      await axios({
        method: "patch",
        url: `${myConfig.API_URL}/observation/${id}/`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
        data: { confirmed: true, confirmed_at: confirmedAt },
      });
      this.setState({ confirmingObsId: null });
      this.loadObservations();
      if (this.props.refreshPending) {
        this.props.refreshPending();
      }
      toast.success(this.props.t("Aplicação confirmada com sucesso!"), {
        position: "bottom-right",
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(this.props.t("Erro ao confirmar aplicação"), {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }

  handleFilterByObservation(obs) {
    const period = getObservationMapPeriod(obs);
    this.shouldScrollToMap = true;
    this.setState({ dt_ini: period.start, dt_end: period.end }, () => {
      this.handleFilter({ preventDefault: () => {} });
    });
  }

  handleOpenObservationsFromMap(data) {
    this.setState({
      showProductsModal: true,
      prefillObservationDate: data.date,
      filterDate: data.date,
    });
  }

  timer() {
    this.getDataValue();
  }

  fetchAccumulatedSummary() {
    return axios({
      baseURL: this.PROGRESS_DETAIL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }).then(({ data }) => {
      this.setState({
        accumulatedHodometer: data.hodometer,
        accumulatedAlerts: data.alert,
      });
    });
  }

  async getDataValue() {
    const generation = this.beginProgressLoad();
    let { data } = await axios.get(this.OPERATION_DATETIME);
    console.log("data", data);
    this.DATA_INIT_OPERATION = new Date(data.dt_ini);

    const todayStart = this.setInitTimeOfDay(new Date());
    const todayEnd = this.setEndTimeOfDay(new Date());
    const PROGRESS_FILTER_URL =
      this.PROGRESS_DETAIL + buildUtcRangeQueryParams(todayStart, todayEnd);
    axios({
      baseURL: PROGRESS_FILTER_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      .then((res) => {
        if (this.isStaleProgressLoad(generation)) return;
        if (res.status === 200) {
          const operation = res.data;
          const widget = res.data.widget;
          let selected = "";
          console.log("operation", operation);

          let dt_end =
            data.end > operation.position_range.end
              ? data.end
              : operation.position_range.end;
          let dt_ini =
            data.init > operation.position_range.end
              ? data.init
              : operation.position_range.init;

          if (operation.fineshed_at !== null) {
            selected = [new Date(dt_ini), new Date(dt_end)];
          } else {
            let selectedDay = new Date();
            selected = [
              this.setInitTimeOfDay(selectedDay),
              this.setEndTimeOfDay(selectedDay),
            ];
          }
          const storedSpeed = readStoredPlannedSpeed(
            this.farmId,
            this.operationId
          );
          const plannedSpeedKmh = clampPlannedSpeed(
            storedSpeed != null
              ? storedSpeed
              : Number(operation.speed) || PLANNED_SPEED_DEFAULT
          );
          const autoMonitoring = Boolean(operation.auto_monitoring);
          const dtIni = selected[0];
          const dtEnd = selected[1];

          this.setState(
            {
              operation: {
                title: operation.ident,
                dt_ini: operation.dt_ini,
                finished_at: operation.fineshed_at,
                cost: operation.cost,
                width: operation.width,
                hodometer: operation.hodometer,
                machine: operation.machine,
                implement: operation.impl,
                operator: operation.operator,
                area: operation.worked_area.area,
                land_plot: operation.land_plot,
                status: {
                  class: operation.status.class,
                  progress: operation.status.progress,
                },
              },
              alert: {
                speed_alert_amount: operation.alert.speed_alert_amount,
                stopped_alert_amount: operation.alert.stopped_alert_amount,
                landplot_alert_amount: operation.alert.landplot_alert_amount,
              },
              plannedSpeedKmh,
              speedDraft: String(plannedSpeedKmh),
              lastProgressSnapshot: { operation, widget },
              ...this.buildProgressMapState(widget, plannedSpeedKmh, autoMonitoring),
              kpi_data: this.buildKpiData(
                operation,
                widget,
                plannedSpeedKmh,
                this.state.fuelPeriodStats,
                dtIni,
                dtEnd,
                this.state.fieldEventSummary,
                autoMonitoring,
                emptyMonitoringMetrics()
              ),
              selected: selected,
              dt_ini: dtIni,
              dt_end: dtEnd,
              graphBrushRange: { startIndex: 0, endIndex: null },
              valid_dates: {
                init: new Date(data.dt_ini),
                end: new Date(dt_end),
              },
              autoMonitoring,
              pendingLandplotName: operation.landplot_name || "",
            },
            () => {
              this.loadFieldEvents(generation);
              if (!this.state.autoMonitoring) {
                this.syncGraphFocusFromPeriod();
              }
              this.applyTelemetryDayFromUrl();
            }
          );
          // console.log(`LOAD INIT ${selected[0]}`);
          this.DATA_END_OPERATION = selected[1];
          if (widget.operation_type !== "covering") {
            this.loadLandPlots();
          } else {
            this.setState({ loading: false });
          }
        } else {
          this.setState({
            errors: this.state.errors.concat(
              getErrorComponent(res.data.detail),
            ),
            loading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          errors: this.state.errors.concat(
            getErrorComponent(default_error_message),
          ),
          loading: false,
        });
      });
  }

  loadLandPlots() {
    Promise.all([
      axios({
        baseURL: this.LANDPLOT_URL,
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      }),
      fetchGroupFarms(this.farmId).catch(() => []),
    ])
      .then(([landRes, groupFarms]) => {
        const landplots =
          landRes.status === 200 && Array.isArray(landRes.data)
            ? landRes.data
            : [];
        this.setState(
          {
            landplots,
            groupFarms: Array.isArray(groupFarms) ? groupFarms : [],
            loading: false,
          },
          () => {
            this.applyMachineScheduleFilterDefaults(landplots, groupFarms);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  handleDelete(event) {
    event.preventDefault();

    if (!window.confirm("Deseja deletar a operação ? ")) {
      // console.log("não deletou");
      return 0;
    } else {
      axios({
        method: "DELETE",
        url: this.DELETE_URL,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      }).then((res) => {
        alert("Operação deletada com sucesso !");
        window.location.href = this.OPERATION_LIST_URL;
      });
    }
  }

  handleDateChange(e) {
    this.setState({
      dt_ini: getFormatedDate(e),
    });
  }

  componentWillMount() {
    this.setState({
      loading: true,
    });

    let ALERT_URL = `${myConfig.API_URL}/alert/?operation=${this.operationId}`;

    axios({
      baseURL: ALERT_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }).then((res) => {
      this.setState({
        alerts: res.data,
      });
    });

    this.getDataValue();
    this.fetchAccumulatedSummary();
    this.loadObservations();
    this.scheduleLiveEquipmentPoll();
  }

  loadLiveEquipmentPosition = () => {
    const ident =
      this.state.operation &&
      this.state.operation.machine &&
      this.state.operation.machine.ident;
    if (!ident) return;

    axios({
      url: `${myConfig.API_URL}/equipment/equipments_info/?farm_id=${this.farmId}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      .then((res) => {
        if (res.status !== 200 || !Array.isArray(res.data)) return;
        const match = res.data.find(function (item) {
          return item.ident === ident;
        });
        if (!match || !match.last_posi_point) return;
        this.setState({
          liveEquipment: {
            lat: match.last_posi_point.lat,
            lng: match.last_posi_point.lng,
            speed: match.speed,
            last_connection: match.last_connection,
            machine_status: match.machine_status,
            traccar_ico: match.traccar_ico,
          },
        });
      })
      .catch(function () {});
  };

  scheduleLiveEquipmentPoll = () => {
    this.loadLiveEquipmentPosition();
    this.liveEquipmentTimer = window.setTimeout(() => {
      this.scheduleLiveEquipmentPoll();
    }, 30000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.liveEquipmentTimer) {
      clearTimeout(this.liveEquipmentTimer);
    }
  }

  setInitTimeOfDay(date) {
    let temp = new Date(date);
    temp.setHours(0);
    temp.setMinutes(0);
    temp.setSeconds(0);
    return temp;
  }

  setEndTimeOfDay(date) {
    let temp = new Date(date);
    temp.setHours(23);
    temp.setMinutes(59);
    temp.setSeconds(59);
    return temp;
  }

  getFastFilterData(range) {
    let data = {},
      today = new Date(),
      temp = "",
      week = "";

    switch (range) {
      case "today":
        data = {
          init: this.setInitTimeOfDay(today),
          end: this.setEndTimeOfDay(today),
        };
        break;
      case "yesterday":
        let yesterday = new Date(today.setDate(today.getDate() - 1));
        data = {
          init: this.setInitTimeOfDay(yesterday),
          end: this.setEndTimeOfDay(today),
        };
        break;
      case "week":
        temp = new Date(today);
        week = new Date(temp.setDate(temp.getDate() - temp.getDay()));
        data = {
          init: this.setInitTimeOfDay(week),
          end: this.setEndTimeOfDay(today),
        };
        break;
      case "last_week":
        const TOTAL_DAYS_WEEK = 8;
        temp = new Date(today);
        week = new Date(temp.setDate(temp.getDate() - temp.getDay()));
        let tmp_week = new Date(week);
        let last_week = new Date(
          tmp_week.setDate(tmp_week.getDate() - TOTAL_DAYS_WEEK),
        );
        let saturday_week = new Date(week.setDate(week.getDate() - 1));
        data = {
          init: this.setInitTimeOfDay(last_week),
          end: this.setEndTimeOfDay(saturday_week),
        };
        break;
      case "all_days":
        // console.log(`STATE ==> ${this.state.dt_ini} && ${this.state.dt_end}`);

        // console.log(
        //   `GLOBAL VARIABLES ==> ${this.DATA_INIT_OPERATION} && ${this.DATA_END_OPERATION}`
        // );

        // t  = selected[1]
        //  = selected[0]
        data = {
          init: this.DATA_INIT_OPERATION,
          end: this.DATA_END_OPERATION,
        };
        break;
      default:
        return "today";
    }
    // console.log(`ANTES DE SETAR O ESTADO ${data.init} && ${data.end}`);
    // console.log(
    //   `GLOBAL VARIABLES ==> ${this.DATA_INIT_OPERATION} && ${this.DATA_END_OPERATION}`
    // );
    this.setState({
      dt_ini: data.init,
      dt_end: data.end,
    });
  }

  async loadFieldEvents(expectedGeneration) {
    if (!this.state.dt_ini || !this.state.dt_end) return;
    const generation =
      expectedGeneration != null
        ? expectedGeneration
        : this.progressLoadGeneration;
    const requestDtIni = this.state.dt_ini;
    const requestDtEnd = this.state.dt_end;

    let url =
      `${myConfig.API_URL}/operation/${this.operationId}/field-events/?farm_id=${this.farmId}` +
      buildUtcRangeQueryParams(requestDtIni, requestDtEnd);

    if (this.state.filterOperatorId) {
      url += `&operator_id=${encodeURIComponent(this.state.filterOperatorId)}`;
    }

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      if (
        this.isStaleProgressLoad(generation) ||
        requestDtIni !== this.state.dt_ini ||
        requestDtEnd !== this.state.dt_end
      ) {
        return;
      }
      this.setState(
        {
          fieldEvents: data.events || [],
          panelPhotos: data.panelPhotos || [],
          fieldEventOperators: data.operators || [],
          fieldEventSummary: normalizeFieldEventSummary(data.summary),
        },
        () => {
          this.patchKpiFromLiveData();
          this.loadFieldTracking(generation, requestDtIni, requestDtEnd);
          if (this.state.autoMonitoring && this.state.machineScheduleExpanded) {
            this.loadMachineSchedule();
          }
        }
      );
    } catch (error) {
      if (this.isStaleProgressLoad(generation)) return;
      this.setState({
        fieldEvents: [],
        fieldEventOperators: [],
        fieldEventSummary: emptyFieldEventSummary(),
        panelPhotos: [],
        fieldTracking: null,
      });
    }
  }

  applyTrackingMapToState(tracking, plannedSpeedKmh, callback) {
    const apiLines =
      tracking && tracking.map && tracking.map.lines ? tracking.map.lines : [];
    if (!apiLines.length) {
      if (callback) callback();
      return;
    }
    const mapBuilt = buildMapFromLines(apiLines, plannedSpeedKmh);
    let centroidLat = tracking.map.centroidLat;
    let centroidLng = tracking.map.centroidLng;
    if (
      (centroidLat == null || centroidLng == null) &&
      mapBuilt.rawPathPoints.length
    ) {
      centroidLat = mapBuilt.rawPathPoints[0].lat;
      centroidLng = mapBuilt.rawPathPoints[0].lng;
    }
    this.setState(
      {
        rawPathPoints: mapBuilt.rawPathPoints,
        graphSeries: mapBuilt.graphSeries,
        map: {
          centroidLat,
          centroidLng,
          geojson: tracking.map.geojson || "",
          lines: mapBuilt.lines,
          operation_type: tracking.map.operation_type || "field_app",
          stopped_points: mapBuilt.stopped_points,
        },
        map_salt: Date.now(),
        graphBrushRange: { startIndex: 0, endIndex: null },
        visibleGraphRange: { startTimeMs: null, endTimeMs: null },
      },
      () => {
        if (callback) callback();
        this.syncGraphFocusFromPeriod();
      }
    );
  }

  async loadFieldTracking(expectedGeneration, requestDtIni, requestDtEnd) {
    const generation =
      expectedGeneration != null
        ? expectedGeneration
        : this.progressLoadGeneration;
    const dtIni = requestDtIni != null ? requestDtIni : this.state.dt_ini;
    const dtEnd = requestDtEnd != null ? requestDtEnd : this.state.dt_end;
    if (!dtIni || !dtEnd) return;

    let url =
      `${myConfig.API_URL}/operation/${this.operationId}/field-tracking/?farm_id=${this.farmId}` +
      buildUtcRangeQueryParams(dtIni, dtEnd);

    if (this.state.filterOperatorId) {
      url += `&operator_id=${encodeURIComponent(this.state.filterOperatorId)}`;
    }

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      if (
        this.isStaleProgressLoad(generation) ||
        dtIni !== this.state.dt_ini ||
        dtEnd !== this.state.dt_end
      ) {
        return;
      }
      this.setState(
        {
          fieldTracking: data,
          fuelPeriodStats: {
            totalLiters: (data.fuelSummary && data.fuelSummary.totalLiters) || 0,
            recordCount: (data.fuelSummary && data.fuelSummary.recordCount) || 0,
            avgLitersPerStop:
              (data.fuelSummary && data.fuelSummary.avgLitersPerStop) || 0,
          },
        },
        () => {
          if (this.state.autoMonitoring) {
            this.applyTrackingMapToState(
              data,
              this.state.plannedSpeedKmh,
              () => {
                this.patchKpiFromLiveData();
                if (this.state.machineScheduleExpanded) {
                  this.loadMachineSchedule();
                }
              }
            );
          } else {
            this.patchKpiFromLiveData();
          }
        }
      );
    } catch (error) {
      if (this.isStaleProgressLoad(generation)) return;
      this.setState((prev) => ({
        fieldTracking: prev.fieldTracking
          ? { ...prev.fieldTracking, map: prev.fieldTracking.map || { lines: [] } }
          : null,
      }));
    }
  }

  getActivityLanes() {
    const graphData = this.handleGraphData();
    const tracking = this.state.fieldTracking;
    if (!tracking) return [];

    if (this.state.autoMonitoring) {
      const visibleGraphData = this._getVisibleGraphSeries();
      const chartGraphData = visibleGraphData.length
        ? visibleGraphData
        : graphData;
      if (!chartGraphData.length) return [];

      const machineIdent =
        this.state.operation &&
        this.state.operation.machine &&
        this.state.operation.machine.ident;
      const normalized = machineIdent
        ? String(machineIdent).trim().toUpperCase()
        : "";

      const machineApiLanes = (tracking.activityLanes || []).filter(
        (lane) =>
          lane.type === "machine" &&
          (!normalized ||
            String(lane.label || "")
              .trim()
              .toUpperCase() === normalized)
      );

      const lanesForGraph =
        machineApiLanes.length > 0
          ? machineApiLanes
          : machineIdent
          ? [
              {
                id: `machine-${machineIdent}`,
                type: "machine",
                label: machineIdent,
                intervals: [],
              },
            ]
          : [];

      return buildMachineLanesMatchingGraph(
        tracking,
        lanesForGraph,
        chartGraphData
      );
    }

    if (!graphData.length) return [];

    const trackingForLanes = {
      activityLanes: tracking.activityLanes || [],
      machines: tracking.machines || [],
      operatorPointCount: tracking.operatorPointCount || 0,
      telemetryGraphData: buildGraphSeriesFromLines(
        tracking.operatorGraphLines || []
      ),
    };

    return buildDisplayActivityLanes(trackingForLanes, graphData);
  }

  getFullPeriodFuelStats() {
    const summary =
      this.state.fieldTracking && this.state.fieldTracking.fuelSummary;
    if (summary && summary.recordCount > 0) {
      return {
        totalLiters: summary.totalLiters || 0,
        recordCount: summary.recordCount || 0,
        avgLitersPerStop: summary.avgLitersPerStop || 0,
      };
    }
    return this.state.fuelPeriodStats || {
      totalLiters: 0,
      recordCount: 0,
      avgLitersPerStop: 0,
    };
  }

  getAllPeriodFuelRecords() {
    const summary =
      this.state.fieldTracking && this.state.fieldTracking.fuelSummary;
    return (summary && summary.records) || [];
  }

  getFuelSupplyContext() {
    const snapshot = this.state.lastProgressSnapshot;
    const areaHa =
      Number(this.state.operation.area) ||
      Number(
        snapshot &&
          snapshot.operation &&
          snapshot.operation.worked_area &&
          snapshot.operation.worked_area.area
      ) ||
      0;
    const monitoring = this.computeMonitoringMetrics();
    const totalHours =
      monitoring.operatorMeterDelta || monitoring.gpsMotionValue || 0;

    return { totalAreaHa: areaHa, totalHours };
  }

  getPeriodFuelStats() {
    const records =
      (this.state.fieldTracking &&
        this.state.fieldTracking.fuelSummary &&
        this.state.fieldTracking.fuelSummary.records) ||
      [];
    const visibleSeries = this._getVisibleGraphSeries();
    const stats = calculatePeriodMotionStats(visibleSeries);
    const { visibleGraphRange } = this.state;
    const startMs =
      visibleGraphRange.startTimeMs != null
        ? visibleGraphRange.startTimeMs
        : stats.startTimeMs;
    const endMs =
      visibleGraphRange.endTimeMs != null
        ? visibleGraphRange.endTimeMs
        : stats.endTimeMs;
    return fuelStatsForRange(records, startMs, endMs);
  }

  getVisibleFuelRecords() {
    const records =
      (this.state.fieldTracking &&
        this.state.fieldTracking.fuelSummary &&
        this.state.fieldTracking.fuelSummary.records) ||
      [];
    if (!records.length) return [];

    const { visibleGraphRange } = this.state;
    const visibleSeries = this._getVisibleGraphSeries();
    const motionStats = calculatePeriodMotionStats(visibleSeries);
    const startMs =
      visibleGraphRange.startTimeMs != null
        ? visibleGraphRange.startTimeMs
        : motionStats.startTimeMs;
    const endMs =
      visibleGraphRange.endTimeMs != null
        ? visibleGraphRange.endTimeMs
        : motionStats.endTimeMs;

    return records.filter((row) => {
      const ts = new Date(row.timestamp).getTime();
      if (Number.isNaN(ts)) return false;
      if (startMs != null && ts < startMs) return false;
      if (endMs != null && ts > endMs) return false;
      return true;
    });
  }

  getMachinePanelPhotos() {
    return collectMachinePanelPhotos(
      this.state.fieldEvents,
      this.getAllPeriodFuelRecords(),
      this.state.panelPhotos
    );
  }

  openFuelPhoto = (url) => {
    if (!url) return;
    this.setState({ fuelPhotoPreview: url });
  };

  closeFuelPhoto = () => {
    this.setState({ fuelPhotoPreview: null });
  };

  handleOperatorFilterChange = (e) => {
    const generation = this.beginProgressLoad();
    this.setState({ filterOperatorId: e.target.value }, () => {
      this.loadFieldEvents(generation);
    });
  };

  async handleFilter(e, range) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    const generation = this.beginProgressLoad();

    if (range) {
      await this.getFastFilterData(range);
    }

    const requestDtIni = this.state.dt_ini;
    const requestDtEnd = this.state.dt_end;
    const PROGRESS_FILTER_URL =
      this.PROGRESS_DETAIL +
      buildUtcRangeQueryParams(requestDtIni, requestDtEnd);

    axios({
      baseURL: PROGRESS_FILTER_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }).then(({ data }) => {
      if (
        this.isStaleProgressLoad(generation) ||
        requestDtIni !== this.state.dt_ini ||
        requestDtEnd !== this.state.dt_end
      ) {
        return;
      }
      let widget = data.widget;
      let operation = data;

      const plannedSpeedKmh = this.state.plannedSpeedKmh;
      const autoMonitoring = Boolean(operation.auto_monitoring);

      this.setState(
        {
          operation: {
            title: operation.ident,
            dt_ini: operation.dt_ini,
            finished_at: operation.fineshed_at,
            cost: operation.cost,
            hodometer: operation.hodometer,
            width: operation.width,
            machine: operation.machine,
            implement: operation.impl,
            operator: operation.operator,
            area: operation.worked_area.area,
            land_plot: operation.land_plot,
            status: {
              class: operation.status.class,
              progress: operation.status.progress,
            },
          },
          autoMonitoring,
          alert: {
            speed_alert_amount: operation.alert.speed_alert_amount,
            stopped_alert_amount: operation.alert.stopped_alert_amount,
            landplot_alert_amount: operation.alert.landplot_alert_amount,
          },
          lastProgressSnapshot: { operation, widget },
          ...this.buildProgressMapState(widget, plannedSpeedKmh, autoMonitoring),
          kpi_data: this.buildKpiData(
            operation,
            widget,
            plannedSpeedKmh,
            this.state.fuelPeriodStats,
            requestDtIni,
            requestDtEnd,
            this.state.fieldEventSummary,
            autoMonitoring,
            this.computeMonitoringMetrics()
          ),
          loading: false,
          isSelected: false,
          graphBrushRange: { startIndex: 0, endIndex: null },
        },
        () => {
          this.loadFieldEvents(generation);
          if (!autoMonitoring) {
            this.syncGraphFocusFromPeriod();
          }
          if (this.shouldScrollToMap) {
            this.shouldScrollToMap = false;
            this.scrollToMapSection();
          }
        }
      );
    });
  }

  load_kpi_gadget() {
    let gadgets = [];
    for (var i = 0; i < this.state.kpi_data.length; i++) {
      gadgets.push(
        <Kpi_gadget
          key={i}
          label_header={this.state.kpi_data[i].label_header}
          header_value={this.state.kpi_data[i].header_value}
          label_help={this.state.kpi_data[i].label_help}
          content_header={this.state.kpi_data[i].content_header}
          content_value={this.state.kpi_data[i].content_value}
          content_class={this.state.kpi_data[i].content_class}
          footer_header={this.state.kpi_data[i].footer_header}
          footer_value={this.state.kpi_data[i].footer_value}
          header_class={this.state.kpi_data[i].header_class}
        />,
      );
    }
    return gadgets;
  }

  hasReport() {
    try {
      const user = JSON.parse(localStorage.getItem("client"));
      return user.id === 30 || user.email.indexOf("agriconnected.com") !== -1;
    } catch (error) {}
    return false;
  }

  choosePeriod(e) {
    this.setState({
      period_id: e.target.value,
      isSelected: true,
    });
  }

  setPeriod(e) {
    let { isSelected } = this.state;
    let selectd_period = parseInt(this.state.period_id);

    if (isSelected === false) return this.handleFilter(e);

    if (selectd_period === 0) return this.handleFilter(e, "today");
    if (selectd_period === 1) return this.handleFilter(e, "yesterday");
    if (selectd_period === 2) return this.handleFilter(e, "week");
    if (selectd_period === 3) return this.handleFilter(e, "last_week");
    if (selectd_period === 4) return this.handleFilter(e, "all_days");
  }

  getOperationValues() {
    const visibleSeries = this._getVisibleGraphSeries();
    const stats = calculatePeriodMotionStats(visibleSeries);
    const periodFuelStats = this.getFullPeriodFuelStats();
    const monitoringMetrics = this.computeMonitoringMetrics();
    const panelPhotos = this.getMachinePanelPhotos();

    const rows = [
      {
        title: "Máquina",
        value: this.state.operation.machine.ident,
      },
      {
        title: "Implemento",
        value: this.state.operation.implement,
      },
      {
        title: "Operador",
        value: this.state.operation.operator,
      },
      {
        title: "Hora de início",
        value: formatPeriodTimestamp(stats.startTimeMs),
      },
      {
        title: "Hora de fim",
        value: formatPeriodTimestamp(stats.endTimeMs),
      },
      {
        title: "Tempo em movimento",
        value: formatPeriodClockDuration(stats.inMotionTimeMs),
      },
      {
        title: "Tempo imóvel",
        value: formatPeriodClockDuration(stats.idleTimeMs),
      },
      {
        title: "Odômetro do período",
        value: this.state.operation.hodometer || "0.00 Km",
      },
      {
        title: "Área total",
        value: this.state.operation.area + " ha",
      },
      {
        title: this.props.t("Combustível no período"),
        value:
          periodFuelStats.recordCount > 0
            ? `${periodFuelStats.totalLiters} L`
            : "—",
      },
      {
        title: this.props.t("Média por abastecimento"),
        value:
          periodFuelStats.recordCount > 0
            ? `${periodFuelStats.avgLitersPerStop} L`
            : "—",
      },
      {
        title: this.props.t("Abastecimentos no trecho"),
        value:
          periodFuelStats.recordCount > 0
            ? String(periodFuelStats.recordCount)
            : "—",
      },
      {
        title: this.props.t("Fotos do painel"),
        value:
          panelPhotos.length > 0
            ? `${panelPhotos.length} ${panelPhotos.length === 1 ? this.props.t("foto") : this.props.t("fotos")}`
            : this.props.t("Sem foto sincronizada"),
      },
    ];

    if (this.state.autoMonitoring) {
      rows.push(
        {
          title:
            monitoringMetrics.meterMode === "hectare"
              ? this.props.t("Consumo L/ha")
              : this.props.t("Consumo L/km"),
          value:
            monitoringMetrics.meterMode === "hectare"
              ? formatFuelRate(monitoringMetrics.fuelPerHa, "L/ha")
              : formatFuelRate(monitoringMetrics.fuelPerKm, "L/km"),
        },
        {
          title: this.props.t("Consumo L/h (movimento)"),
          value: formatFuelRate(monitoringMetrics.fuelPerHour, "L/h"),
        },
        {
          title: this.props.t("Diferença operador × GPS"),
          value: formatMeterDiff(
            monitoringMetrics.meterDiff,
            monitoringMetrics.meterMode
          ),
        },
        {
          title: this.props.t("Parado com motor ligado"),
          value: formatMonitoringDuration(monitoringMetrics.engineStoppedMs),
        }
      );
    }

    return rows;
  }

  _calculatePolygonArea(data) {
    const toRadians = (degree) => (degree * Math.PI) / 180;
    const R = 6371000; // Radius of Earth in meters

    let area = 0;
    const points = data.map((point) => ({
      lat: toRadians(point.lat),
      lon: toRadians(point.lng),
    }));

    for (let i = 0; i < points.length; i++) {
      const { lat: lat1, lon: lon1 } = points[i];
      const { lat: lat2, lon: lon2 } = points[(i + 1) % points.length];

      area += (lon2 - lon1) * (2 + Math.sin(lat1) + Math.sin(lat2));
    }

    area = Math.abs((area * R * R) / 2.0);

    // Convert area from square meters to hectares (1 hectare = 10,000 square meters)
    const areaInHectares = area / 10000;

    return areaInHectares;
  }
  _formatTime(hours, minutes, seconds) {
    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
    ].join(":");
  }
  _formatSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return this._formatTime(hours, minutes);
  }

  _calculateTotalDistance(data) {
    let totalDistance = 0;

    for (let i = 1; i < data.length; i++) {
      const { lat: lat1, lng: lon1 } = data[i - 1];
      const { lat: lat2, lng: lon2 } = data[i];

      totalDistance += distance(lat1, lon1, lat2, lon2);
    }

    return totalDistance;
  }

  getConsolidatedData = () => {
    const alerts = this.state.accumulatedAlerts || this.state.alert;

    return [
      {
        title: "Odômetro Total Acumulado",
        value:
          this.state.accumulatedHodometer ||
          this.state.operation.hodometer ||
          "0.00 Km",
      },
      {
        title: "Total de alertas de velocidade",
        value: alerts.speed_alert_amount,
      },
      {
        title: "Total de alertas de parada",
        value: alerts.stopped_alert_amount,
      },
      {
        title: "Total de alertas de e/s talhão",
        value: alerts.landplot_alert_amount,
      },
    ];
  };

  _getRelativeDays(dateStr) {
    const now = new Date();
    const date = new Date(dateStr);
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0 && diffMs >= 0) return this.props.t("Hoje");
    if (diffDays === 1) return this.props.t("Ontem");
    if (diffMs < 0) {
      const futureDays = Math.ceil(Math.abs(diffMs) / (1000 * 60 * 60 * 24));
      if (futureDays === 0) return this.props.t("Hoje");
      if (futureDays === 1) return this.props.t("Amanhã");
      return `${this.props.t("em")} ${futureDays} ${this.props.t("dias")}`;
    }
    return `${diffDays} ${this.props.t("dias atrás")}`;
  }

  _getFlatLineArray() {
    if (!this.state.map) return [];
    let { lines = [] } = this.state.map;
    return lines.reduce(
      (acc, { path, color }) => acc.concat(path.map((p) => ({ ...p, color }))),
      [],
    );
  }

  _getVisibleFlatLineArray() {
    const flat = this._getFlatLineArray();
    const visibleSeries = this._getVisibleGraphSeries();
    if (!flat.length || !visibleSeries.length) return [];

    const startTs = visibleSeries[0].timestamp;
    const endTs = visibleSeries[visibleSeries.length - 1].timestamp;
    const startIdx = flat.findIndex((p) => p.time === startTs);
    const endIdx = flat.findIndex((p) => p.time === endTs);

    if (startIdx === -1 || endIdx === -1) {
      const { startIndex, endIndex } = this.state.graphBrushRange;
      const safeEnd =
        endIndex == null || endIndex >= flat.length
          ? flat.length - 1
          : endIndex;
      return flat.slice(startIndex, safeEnd + 1);
    }

    return flat.slice(startIdx, endIdx + 1);
  }

  handleGraphData() {
    return this.state.graphSeries || [];
  }

  handleGraphClick = (point) => {
    const coords = this._getFlatLineArray().find(
      ({ time }) => time === point.timestamp,
    );
    let google = window.google;
    let marker = new google.maps.Marker({
      icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        rotation: coords.course,
        strokeColor: coords.color,
        fillColor: coords.color,
        scale: 3,
        strokeWeight: 3.5,
        fillOpacity: 0.9,
      },
      position: coords,
      map: google.map,
    });
    google.map.setCenter(coords);
    google.map.setZoom(18);
    const t = this.props.t;
    const buildContent = (weatherHtml) =>
      pointDetailsInfoWindowHtml({
        t,
        weatherHtml,
        speed: coords.speed,
        timeLabel: this.formatTraceTime(coords.time),
        relativeTime: formatRelativeTime(coords.time, t),
      });
    let infoWindow = new google.maps.InfoWindow({
      content: buildContent(weatherLoadingHtml(t)),
      maxWidth: 260,
    });
    infoWindow.open(google.map, marker);
    this.weatherHtmlForPoint(coords)
      .then((weatherHtml) => {
        infoWindow.setContent(buildContent(weatherHtml));
      })
      .catch(() => {
        infoWindow.setContent(buildContent(""));
      });
    setTimeout(() => {
      infoWindow.close();
    }, POINT_DETAILS_INFO_WINDOW_MS);
  };

  weatherHtmlForPoint = (point) =>
    loadWeatherInfoWindowHtml({
      farmId: this.farmId,
      point,
      operatorIds: this.getTrackingOperatorIds(),
      t: this.props.t,
    });

  handleSliderChange = (value) => {
    const flatLineArray = this._getFlatLineArray();
    if (flatLineArray.length === 0) return;

    const selectedPoint = flatLineArray[value];
    const google = window.google;

    if (this.marker) {
      this.marker.setMap(null); // Remove marcador anterior
    }

    this.marker = new google.maps.Marker({
      position: { lat: selectedPoint.lat, lng: selectedPoint.lng },
      map: google.map,
      title: `Velocidade: ${selectedPoint.speed}, Hora: ${new Date(
        selectedPoint.time,
      ).toLocaleTimeString()}`,
    });

    google.map.setCenter({ lat: selectedPoint.lat, lng: selectedPoint.lng });
    google.map.setZoom(18);
  };

  get_content() {
    let relatorio = "";
    if (this.state.errors.length > 0) {
      return (
        <div
          style={{
            position: "absolute",
            marginTop: "25%",
            marginLeft: "25%",
            minHeight: "200px",
          }}
        >
          {this.state.errors.map((error) => (
            <div>{error}</div>
          ))}
        </div>
      );
    }

    // FAZENDA ELITE TRANSPORTES
    if (this.hasReport()) {
      if (this.state.operation.status.class === "finished") {
        relatorio = (
          <OperationReport
            farm_id={this.farmId}
            operation_id={this.operationId}
          />
        );
      } else {
        relatorio = (
          <div>
            <button
              type="button"
              className="btn btn-default pull-left"
              onClick={this.handleMessage}
            >
              <FaFileAlt />
              {this.props.t("Gerar Relatório")}
            </button>
          </div>
        );
      }
    }

    return (
      <div className="pt-40 operation-detail-container">
        <PdfContainer createPdf={this.createPdf}>
          <div className="x_content no-float">
            <div className="row tile_count">{this.load_kpi_gadget()}</div>
            <div className="text-center">
              <Title size="h1" title={this.state.operation.title}>
                <p className="inline-block">
                  <i
                    className={classnames(
                      this.state.operation.status.class,
                      "status-indicator",
                    )}
                  ></i>
                  {this.state.operation.status.progress}
                </p>
              </Title>
              {this.getTelemetryReturnUrl() ? (
                <div className="operation-telemetry-return">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={this.handleReturnToTelemetry}
                  >
                    <FaArrowLeft aria-hidden="true" />
                    {this.props.t("Voltar para telemetria")}
                  </button>
                </div>
              ) : null}
              {this.state.autoMonitoring ? (
                <p className="alert alert-info auto-monitoring-banner">
                  {this.props.t(
                    "Monitoramento automático da máquina {{machine}} — use o período para ver combustível, eventos e fotos de todos os operadores que trabalharam neste equipamento.",
                    { machine: this.state.operation.machine.ident }
                  )}
                </p>
              ) : null}
            </div>
            {this.state.autoMonitoring ? (
              <OperationMachinePhotosPanel
                machineIdent={this.state.operation.machine.ident}
                fieldEvents={this.state.fieldEvents}
                fuelRecords={this.getAllPeriodFuelRecords()}
                panelPhotos={this.state.panelPhotos}
                formatTimestamp={this.formatEventTimestamp}
                onOpenPhoto={this.openFuelPhoto}
                t={this.props.t}
              />
            ) : null}
            <div className="flex-box">
              <div className="op-search">
                <div className="x_panel auto mt-0">
                  <div
                    className="select-container"
                    aria-label="Filtros dinamicos"
                  >
                    <label
                      className="col-xs-12 no-padding"
                      htmlFor="select-container"
                    >
                      Período:
                    </label>
                    <SelectBox
                      strong="true"
                      data={this.state.periods}
                      selected_value={this.state.period_id}
                      value={"name"}
                      change={(e) => this.choosePeriod(e)}
                    />
                  </div>
                  <div className="col-filter col-xs-12 pull-left">
                    <AgriDateTime
                      time={getTime(this.state.dt_ini)}
                      align="horizontal"
                      timeLabel={this.props.t("Hora Inicio")}
                      label={this.props.t("Data inicial")}
                      datetimeformat="true"
                      selectedDate={this.state.dt_ini}
                      handleDateChange={this.handleStartDateChange}
                      validDates={this.state.valid_dates}
                      handleTimeChange={this.handleStartTimeChange}
                    />
                  </div>
                  <div className="col-filter col-xs-12 pull-left">
                    <AgriDateTime
                      time={getTime(this.state.dt_end)}
                      align="horizontal"
                      timeLabel={this.props.t("Hora Fim")}
                      label={this.props.t("Data Fim")}
                      validDates={this.state.valid_dates}
                      datetimeformat="true"
                      selectedDate={this.state.dt_end}
                      handleDateChange={this.handleChangeDateEnd}
                      handleTimeChange={this.handleEndTimeChange}
                    />
                  </div>
                  <Button
                    class="btn btn-info pull-left form-control w-40 btn-fast-filter mt-25 lh-25"
                    click={(e) => this.setPeriod(e)}
                  >
                    <FaSearch />
                  </Button>
                  <div className="select-container col-xs-12">
                    <label htmlFor="field-operator-filter">{this.props.t("Operador")}:</label>
                    <select
                      id="field-operator-filter"
                      className="form-control"
                      value={this.state.filterOperatorId}
                      onChange={this.handleOperatorFilterChange}
                    >
                      <option value="">{this.props.t("Todos os operadores")}</option>
                      {(this.state.fieldEventOperators || []).map((op) => (
                        <option key={op.id} value={op.id}>
                          {op.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {this.state.autoMonitoring ? (
                    <div className="col-xs-12">
                      <OperationFieldEventsPanel
                        events={this.state.fieldEvents}
                        summary={this.state.fieldEventSummary}
                        expanded={this.state.fieldEventsExpanded}
                        onToggle={this.toggleFieldEventsExpanded}
                        formatTimestamp={this.formatEventTimestamp}
                        onOpenPhoto={this.openFuelPhoto}
                        meterType={
                          this.state.operation &&
                          this.state.operation.machine &&
                          this.state.operation.machine.meter_type
                        }
                        t={this.props.t}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="x_content">
                  <div className="field-app-speed-ref-control operation-speed-ref-control">
                    <button
                      type="button"
                      className={`field-app-speed-ref-btn${
                        this.state.speedEditorOpen ? " is-active" : ""
                      }`}
                      title={this.props.t("Alterar velocidade de referência")}
                      aria-label={this.props.t("Alterar velocidade de referência")}
                      onClick={this.toggleSpeedEditor}
                    >
                      <FaTachometerAlt />
                    </button>
                    <span className="field-app-speed-ref-value">
                      {this.props.t("Velocidade planejada")}:{" "}
                      <strong>{this.state.plannedSpeedKmh} km/h</strong>
                    </span>
                    {this.state.speedEditorOpen ? (
                      <div className="field-app-speed-ref-panel">
                        <label htmlFor="operation-planned-speed">
                          {this.props.t("Velocidade de referência (km/h)")}
                        </label>
                        <input
                          id="operation-planned-speed"
                          type="number"
                          min="1"
                          max="120"
                          step="0.5"
                          value={this.state.speedDraft}
                          onChange={(event) =>
                            this.setState({ speedDraft: event.target.value })
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter") this.applyPlannedSpeed();
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={this.applyPlannedSpeed}
                        >
                          {this.props.t("Aplicar")}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <ul className="list-unstyled">
                    <li className="pull-left col-md-3 text-xs-center col-xs-12">
                      <i className="line red-border"></i>
                      {this.props.t("Acima da velocidade")}
                    </li>
                    <li className="pull-left col-md-3 text-xs-center col-xs-12">
                      <i className="line blue-border"></i>
                      {this.props.t("Dentro da velocidade")}
                    </li>
                    <li className="pull-left col-md-3 text-xs-center col-xs-12">
                      <i className="line yellow-border"></i>
                      {this.props.t("Abaixo da velocidade")}
                    </li>
                    <li className="pull-left col-md-3 text-xs-center col-xs-12">
                      <i className="line white-border"></i>
                      {this.props.t("Fora do talhão")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="operation-map-toolbar">
              <FieldAppTimezoneToggle
                mode={this.state.timezoneMode}
                onModeChange={this.handleTimezoneModeChange}
                t={this.props.t}
              />
            </div>
            <div className="operation-map-graph-stack">
            <div className="map-container" ref={this.mapSectionRef}>
              <MapContainer
                map={this.state.map}
                map_salt={`${this.state.map_salt || 0}-${this.state.plannedSpeedKmh}-${this.state.timezoneMode}`}
                operation_id={this.operationId}
                farm_id={this.farmId}
                equipment={resolveOperatorMapEquipment(
                  this.state.fieldTracking &&
                    this.state.fieldTracking.equipment,
                  this.state.liveEquipment
                )}
                livePosition={this.state.liveEquipment}
                landplots={this.state.landplots}
                onOpenObservations={this.handleOpenObservationsFromMap}
                formatTraceTime={this.formatTraceTime}
                weatherHtmlForPoint={this.weatherHtmlForPoint}
                t={this.props.t}
              />
            </div>
            <LineGraph
              data={this.state.graphSeries}
              period={this.getPeriod()}
              refValue={this.state.plannedSpeedKmh}
              onClick={this.handleGraphClick}
              onRangeChange={this.handleGraphRangeChange}
              focusBrushRange={this.state.focusBrushRange}
              activityLanes={this.getActivityLanes()}
              showActivityBand={this.getActivityLanes().length > 0}
              brushOnlyZoom
              formatChartTime={this.formatChartTime}
              onActivityIntervalClick={this.handleActivityIntervalClick}
            />
            {this.state.selectedActivityInterval ? (
              <FieldAppActivitySessionDetail
                selection={this.state.selectedActivityInterval}
                formatTimestamp={this.formatTrackingTimestamp}
                onClose={() => this.setState({ selectedActivityInterval: null })}
                farmId={this.farmId}
                operatorIds={this.getTrackingOperatorIds()}
                fuelRecords={this.getTrackingFuelRecords()}
                defaultSinceDay={dayKeyFromIso(this.state.dt_ini)}
                operationId={this.operationId}
              />
            ) : null}
            </div>
            {this.state.autoMonitoring &&
            this.state.operation &&
            this.state.operation.machine &&
            this.state.operation.machine.ident ? (
              <div className="field-app-machine-schedule-section">
                <FieldAppMachineSchedulePanel
                expanded={this.state.machineScheduleExpanded}
                onToggleExpanded={this.handleMachineScheduleToggle}
                rows={this.state.machineScheduleRows}
                meterType={this.state.machineScheduleMeterType}
                loading={this.state.machineScheduleLoading}
                error={this.state.machineScheduleError}
                timezoneMode={this.state.timezoneMode}
                farmId={this.farmId}
                selection={{
                  operatorIds: this.getTrackingOperatorIds(),
                  dateFrom: this.state.dt_ini,
                  dateTo: this.state.dt_end,
                }}
                machineLabel={this.state.operation.machine.ident}
                machineOptions={[this.state.operation.machine.ident]}
                landplots={this.state.landplots}
                groupFarms={this.state.groupFarms}
                selectedSubFarmId={this.state.machineScheduleSubFarmId}
                onSubFarmChange={this.handleMachineScheduleSubFarmChange}
                selectedLandplotId={this.state.machineScheduleLandplotId}
                selectedLandplotName={this.state.machineScheduleLandplotName}
                onLandplotChange={this.handleMachineScheduleLandplotChange}
                periodLabel={this.getSchedulePeriodLabel()}
                operatorLabel={this.getScheduleOperatorLabel()}
                t={this.props.t}
              />
              </div>
            ) : null}
            {this.state.fuelPhotoPreview ? (
              <div
                className="operation-fuel-photo-modal"
                role="dialog"
                aria-modal="true"
                onClick={this.closeFuelPhoto}
              >
                <div
                  className="operation-fuel-photo-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="btn btn-default btn-sm operation-fuel-photo-close"
                    onClick={this.closeFuelPhoto}
                  >
                    {this.props.t("Fechar")}
                  </button>
                  <img
                    src={this.state.fuelPhotoPreview}
                    alt={this.props.t("Foto do painel")}
                    className="operation-fuel-photo-image"
                  />
                </div>
              </div>
            ) : null}
            <div className="row">
              <CardContent
                title={this.props.t("Resumo do Período Selecionado")}
                description={this.props.t(
                  "Estes dados correspondem ao trecho visível no gráfico (≥ 1 km/h, parado se > 4 min sem coordenada)",
                )}
                borderColor="#28a745"
                data={this.getOperationValues()}
              />
              {this.getAllPeriodFuelRecords().length > 0 ? (
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div
                    className="x_panel mt-10 operation-fuel-supply-card"
                    style={{
                      border: "2px solid #f0ad4e",
                      borderRadius: "5px",
                      padding: "15px",
                    }}
                  >
                    <OperationFuelSupplyPanel
                      records={this.getAllPeriodFuelRecords()}
                      totalAreaHa={this.getFuelSupplyContext().totalAreaHa}
                      totalHours={this.getFuelSupplyContext().totalHours}
                      formatTimestamp={this.formatEventTimestamp}
                      onOpenPhoto={this.openFuelPhoto}
                      t={this.props.t}
                      defaultDateFrom={
                        this.state.dt_ini
                          ? String(this.state.dt_ini).slice(0, 10)
                          : ""
                      }
                      defaultDateTo={
                        this.state.dt_end
                          ? String(this.state.dt_end).slice(0, 10)
                          : ""
                      }
                    />
                  </div>
                </div>
              ) : null}
              {this.getVisibleFuelRecords().length > 0 &&
              this.getVisibleFuelRecords().length <
                this.getAllPeriodFuelRecords().length ? (
                <CardContent
                  title={this.props.t("Abastecimentos no trecho visível")}
                  description={this.props.t(
                    "Subconjunto do período conforme o zoom do gráfico abaixo."
                  )}
                  borderColor="#e8c87a"
                >
                  <ul className="list-unstyled operation-fuel-records-list">
                    {this.getVisibleFuelRecords().map((record) => (
                      <li
                        key={`visible-${record.uuid || record.timestamp}`}
                        className="operation-fuel-record-item"
                      >
                        <strong>
                          {this.formatEventTimestamp(record.timestamp)}
                        </strong>
                        {" — "}
                        {record.liters} L
                      </li>
                    ))}
                  </ul>
                </CardContent>
              ) : null}
              <CardContent
                title={this.props.t(
                  "Resumo Total Acumulado (Desde o Início da Tarefa)",
                )}
                subtitle={
                  this.props.t("Tarefa aberta em") +
                  ": " +
                  changeToBrowserTimezone(this.state.operation.dt_ini)
                }
                description={this.props.t(
                  "Estes dados são o total acumulado desde o início da operação",
                )}
                borderColor="#007bff"
                data={this.getConsolidatedData()}
              >
                <SimpleModal alerts={this.state.alerts} />
              </CardContent>

              {/* Card de Produtos e Observações */}
              <CardContent
                title={
                  <>
                    <FaLeaf className="mr-2" />
                    {this.props.t("Produtos e Observações")}
                  </>
                }
                description={this.props.t(
                  "Registros de produtos aplicados e observações da operação",
                )}
                borderColor="#fd7e14"
              >
                <div className="x_content">
                  {this.state.observation_entries &&
                  this.state.observation_entries.length > 0 ? (
                    <div>
                      {this.state.observation_entries.map((obs) => (
                          <div key={obs.id} className={getObsCardClass(obs)}>
                            <button
                              onClick={() =>
                                this.handleFilterByObservation(obs)
                              }
                              title={
                                hasExecutedPeriod(obs)
                                  ? this.props.t(
                                      "Ver rastreamento do período executado"
                                    )
                                  : this.props.t(
                                      "Ver rastreamento do período solicitado"
                                    )
                              }
                              style={{
                                position: "absolute",
                                top: "6px",
                                right: "8px",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: "#555",
                                padding: "2px",
                              }}
                            >
                              <FaFilter />
                            </button>
                            <ObservationExecutionInfo
                              obs={obs}
                              t={this.props.t}
                            />
                            <ScheduledBadge
                              obs={obs}
                              onConfirm={this.handleConfirmObservation}
                            />
                            {obs.products_used && (
                              <div style={{ marginTop: "4px" }}>
                                <small>
                                  <strong>
                                    <FaLeaf style={{ marginRight: "4px" }} />
                                    {this.props.t("Produtos Utilizados")}:
                                  </strong>
                                </small>
                                <pre
                                  style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: "12px",
                                    margin: "2px 0",
                                    padding: "4px 8px",
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {obs.products_used}
                                </pre>
                              </div>
                            )}
                            <div style={{ marginTop: "4px" }}>
                              <p
                                style={{
                                  fontSize: "13px",
                                  margin: "2px 0",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {obs.description}
                              </p>
                            </div>
                            {showsHarvestLossFields(obs.service_type) ? (
                              <FieldAppHarvestLossOrderResults
                                farmId={this.farmId}
                                observationId={obs.id}
                                serviceOrderPlan={obs.service_order_plan}
                                selection={{}}
                                t={this.props.t}
                              />
                            ) : null}
                          </div>
                        ))}
                      </div>
                  ) : (
                    <div className="alert alert-info">
                      <FaInfoCircle className="mr-2" />
                      {this.props.t("Nenhuma observação registrada")}
                    </div>
                  )}
                </div>
              </CardContent>
            </div>
            {alert}
            <div className="row">
              <div className="text-center mt-10 col-xs-12">
                <Button
                  class="btn-default pull-left"
                  href={this.OPERATION_LIST_URL}
                >
                  {this.props.t("Voltar")}
                </Button>
                {/* <Button class="btn btn-default pull-left btn-reprocess" click={this.handleShowModal}><i className="fas fa-sync-alt mr-5"></i>{this.props.t('Reprocessar')}</Button> */}
                <OperationReprocess operation_id={this.operationId} />
                {relatorio}
                <div className="pull-right">
                  {/* Botão Produtos e Observações */}
                  <Button
                    class="btn-warning"
                    click={this.handleShowCreateLandplotModal}
                  >
                    <FaDrawPolygon />
                    {this.props.t("Criar Talhão")}
                  </Button>
                  <Button
                    class="btn-success"
                    click={this.handleShowProductsModal}
                  >
                    <FaLeaf />
                    {this.props.t("Produtos e Observações")}
                  </Button>
                  <Button class="btn-info" href={this.UPDATE_URL}>
                    <FaPen />
                    {this.props.t("Editar")}
                  </Button>
                  <Button class="btn-danger" click={this.handleDelete}>
                    <FaTrashAlt />
                    {this.props.t("Apagar")}
                  </Button>
                  {!this.state.autoMonitoring ? (
                    <Button class="btn-primary" click={this.handleFinished}>
                      <FaCheckCircle />
                      {this.props.t("Finalizar")}
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </PdfContainer>

        {/* Modal de Produtos e Observações */}
        <ProductsModal
          show={this.state.showProductsModal}
          onHide={this.handleCloseProductsModal}
          observations={this.state.observation_entries}
          onAddObservation={this.handleAddObservation}
          onUpdateObservation={this.handleUpdateObservation}
          onDeleteObservation={this.handleDeleteObservation}
          onConfirmObservation={this.handleConfirmObservation}
          prefillDate={this.state.prefillObservationDate}
          filterDate={this.state.filterDate}
        />

        {/* Modal de Confirmação de Aplicação */}
        <ConfirmApplicationModal
          show={!!this.state.confirmingObsId}
          onHide={this.handleCancelConfirmation}
          onConfirm={this.handleSubmitConfirmation}
        />

        <CreateLandplotModal
          show={this.state.showCreateLandplotModal}
          onHide={this.handleCloseCreateLandplotModal}
          onLandplotCreated={this.handleLandplotCreated}
          map={this.state.map}
          landplots={this.state.landplots}
          farmId={this.farmId}
        />

        <ToastContainer />
      </div>
    );
  }

  render() {
    let content = "";

    if (this.state.loading === false) {
      content = this.get_content();
    } else {
      content = (
        <div
          style={{
            position: "absolute",
            marginTop: "25%",
            marginLeft: "60%",
            minHeight: "200px",
          }}
        >
          <MDSpinner />
        </div>
      );
    }

    return <div>{content}</div>;
  }
}
function OperationDetailWithPending(props) {
  const { refreshPending } = usePendingSchedules();
  return <OperationDetail {...props} refreshPending={refreshPending} />;
}

export default withTranslation()(OperationDetailWithPending);
